import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ENVIRONMENT } from '@company-box/models';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LoggerModule } from 'ngx-logger';
import { environment } from '../environments/environment';
import { bearerTokenHeaderInterceptor } from 'projects/libs/services/src/lib/auth/bearer-token-header-interceptor';
import { accountUnauthorizedInterceptor } from 'projects/libs/services/src/lib/auth/account-unauthorized-interceptor';
import { CBAuthService } from './services/cb-auth.service';
import { AUTH_SVC } from '@company-box/services';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    // provideRouter(routes, withDebugTracing()),
    provideHttpClient(withInterceptors([accountUnauthorizedInterceptor, bearerTokenHeaderInterceptor])),
    importProvidersFrom([
      BrowserAnimationsModule,
      LoggerModule.forRoot({
        serverLoggingUrl: environment.logger.serverLoggingUrl,
        level: environment.logger.logLevel,
        serverLogLevel: environment.logger.serverLogLevel,
      }),
      ModalModule.forRoot(),
    ]),
    provideAnimations(),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: AUTH_SVC, useClass: CBAuthService}
  ],
};
